//==========================Pre-loader=======================//
$(document).ready(function(){
	window.ajax_cart = true;
  	jQuery(window).load(function() { jQuery(".ttloader").fadeOut("slow"); });
});

//==========================back-to-top=======================//
$(window).scroll(function() {
if ($(this).scrollTop() > 500) {
$('.top_button').fadeIn(500);
} else {
$('.top_button').fadeOut(500);
}
});	
$('.top_button').click(function(event) {
event.preventDefault();	
$('html, body').animate({scrollTop: 0}, 800);
});

//==================== account toggle ====================//
$(document).ready(function(){
	$(".site-header__account .account-icon").click(function(){
	$(".site-header__account .account-dropdown").slideToggle(500);
	$('.site-header__account').toggleClass('active'); 
	});
});


//==================== cart toggle ====================//
$(document).ready(function(){
	$(".site-header__cart").click(function(){
	$(".site-header__cart .cart-content.block").slideToggle(500);
	$('.site-header__cart').toggleClass('active'); 
	});
});

//==================== search toggle ====================//
$(document).ready(function(){
	$(".site-header__search .search-icon").click(function(){
	$(".header-search__dropdown").slideToggle(500); 
    $('.site-header__search').toggleClass('active'); 
	});
});

$(document).ready(function() {
  
//========================cmsblock slider==========================// 
$('#bannercms.owl-carousel').owlCarousel({
    loop:false,
    margin:0,
    nav:true,
  	dots: false,
    autoplay: false,
    responsive:{
        0:{
            items:1
        },
        480: {
            items:2
        },
        750:{
            items:3
        },
        1000:{
            items:3
        }
    }
})

//=============================== Quotes Slider ==================================//
$('.quotes-slider.owl-carousel').owlCarousel({
    loop:true,
    margin: 0,
    nav:false,
  	dots: false,
    autoplay: true,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:1
        },
        1000:{
            items:1
        }
    }
})

//========================brand slider==========================//
$('#brand-slider.owl-carousel').owlCarousel({
    loop:false,
    margin:10,
    nav:true,
  	dots: false,
    autoplay: false,
    responsive:{
        0:{
            items:1
        },
        480:{
            items:2
        },
        750:{
            items:4
        },
        990:{
            items:5
        },
        1270:{
            items:6
        }
    }
})

//========================blog slider==========================// 

$('#blog_slider.owl-carousel').owlCarousel({
    loop:false,
    nav:true,
  	dots: false,
    autoplay: false,
    responsive:{
        0:{
            items:1
        },
        480:{
            items:1
        },
        750:{
            items:2
        },
        1200:{
            items:3
        }
    }
})

//====================== collection tab product slider =======================// 
$('.tab-slider.owl-carousel').on('changed.owl.carousel initialized.owl.carousel', function(event) {
    $(event.target)
      .find('.owl-item').removeClass('last')
      .eq(event.item.index + event.page.size - 1).addClass('last');
  }).owlCarousel({
    loop: false,
    nav: true,
  	dots: false,
  	rows:1,
    responsive:{
        0:{
            items:1
        },
        480:{
            items:2
        },
      	750:{
            items:3
        },
        990:{
            items:3
        },
        1270:{
            items:4
        }
    }
})

//====================== collection product slider ======================//

$('.slider.owl-carousel').on('changed.owl.carousel initialized.owl.carousel', function(event) {
    $(event.target)
      .find('.owl-item').removeClass('last')
      .eq(event.item.index + event.page.size - 1).addClass('last');
  }).owlCarousel({
    loop:false,
  	//margin:10,
    nav:true,
  	dots: false,
  	rows:2,
    responsive:{
        0:{
            items:1
        },
        480:{
            items:2
        },
      	750:{
            items:3
        },
        990:{
            items:3
        },
        1270:{
            items:4
        }
    }
})

//=============================== Collection list slider =============================//

$('.collection-list-slider .owl-carousel').owlCarousel({
    loop:true,
    margin: 0,
    nav:false,
  	dots: false,
    autoplay: true,
    responsive:{
        0:{
            items:1
        },
        480:{
            items:2
        },
        750:{
            items:3
        },
        1270:{
            items:3
        }
    }
})


//====================== product-thumbnail slider ======================//
$('#thumbnail-carousel.owl-carousel').owlCarousel({
    loop:false,
    margin:15,
    nav:true,
  	dots: false,
    autoplay: false,
    responsive:{
        0:{
            items:2
        },
        480: {
            items:3
        },
        990:{
            items:4
        },
        1270:{
            items:5
        }
    }
})



});
 
//====================== collection tab active js block =======================//
$(document).ready(function() {
    $('.product_tab-block ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
});


/*=====================  More site navigation =======================*/
function more_left() {
  if ($(window).width()  >= 1270) {
    var max_elem = 5;
    var items = $('.header-middle #SiteNav > li');
    var surplus = items.slice(max_elem, items.length);
    surplus.wrapAll('<li class="more-site-nav more-nav hiden_menu"><div class="site-nav__dropdown"><ul>');
    $('.more-nav').prepend('<a class="site-nav__link site-nav__link--main" href="#">more</a>')
  }
  else if (($(window).width() >= 990) && ($(window).width() <= 1269)) {
    var max_elem = 3;
    var items = $('.header-middle #SiteNav > li');
    var surplus = items.slice(max_elem, items.length);
    surplus.wrapAll('<li class="more-site-nav more-nav hiden_menu"><div class="site-nav__dropdown"><ul>');
    $('.more-nav').prepend('<a class="site-nav__link site-nav__link--main" href="#">more</a>')
  }
  else {
    var max_elem = 10;
    var items = $('.header-middle #SiteNav > li');
    var surplus = items.slice(max_elem, items.length);
    surplus.wrapAll('<li class="more-site-nav more-nav hiden_menu"><div class="site-nav__dropdown"><ul>');
    $('.more-nav').prepend('<a class="site-nav__link site-nav__link--main" href="#">more</a>')
  }
}
$(document).ready(function() {
    more_left()
});
 


//====================== collection tab =======================//
$(document).ready(function() {
    $('.product-single__tab ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
});


/*==================sidebar toggle====================*/
function mobileToggleColumn1(){
  if ($(window).width() < 990){
    $(".side-bar h3.box-heading").append( "<span class='mobile_togglemenu'> </span>" );  
    $(".side-bar h3.box-heading").addClass('toggle');
    $(".side-box h3.box-heading").click(function(){
       $(this).toggleClass('active').parent().find('.box-content').slideToggle('slow');
    });    
  }
  else{
    $(".side-bar h3.box-heading").removeClass('toggle');
    $(".side-bar h3.box-heading").removeClass('active');
    $(".side-box .mobile_togglemenu").remove();
  }
}
$(document).ready(mobileToggleColumn1); 


/*==================footer toggle====================*/
function mobileToggleColumn(){
  if ($(window).width() < 990){
    $(".site-footer .footer-box  h5").append( "<span class='mobile_togglemenu'> </span>" );  
    $(".site-footer .footer-box h5").addClass('toggle');
    $(".footer-box .link_title").click(function(){
       $(this).toggleClass('active').parent().find('.footer-content').slideToggle('slow');
    });    
  }
  else{
    $(".site-footer .footer-box  h5").removeClass('toggle');
    $(".site-footer .footer-box h5").removeClass('active');
    $(".footer-box .mobile_togglemenu").remove();
  }
}
$(document).ready(mobileToggleColumn);

//======================mobile menu toogle======================//
$(document).ready(function(){
  $("#MobileNav .mobile-nav__dropdown").parent().append("<span class='mobile_togglecolumn'></span>");
        $('#MobileNav .mobile_togglecolumn').click(function () {
        $(this).parent().toggleClass('active');
        });
  
   $("#MobileNav .mobile-nav__grand_dropdown").parent().append("<span class='mobile_togglecolumn'></span>");
        $('#MobileNav .mobile-nav__grand__item .mobile_togglecolumn').click(function () {
        $(this).parent().toggleClass('active');
   });
});

/*================== sidebar category-box ===================*/
function mobileToggleMenu10(){
    $(".side-bar #CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").append( "<span class='mobile_togglemenu'> </span>" );  
    $(".side-bar #CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").addClass('toggle');
    $(".side-bar #CategoryBox  ul#SiteCat > li.site-cat--has-dropdown .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').find('.site-nav__dropdown').slideToggle('slow');    
    });    
}
$(document).ready(mobileToggleMenu10);

function mobileToggleMenu11(){
    $(".side-bar #CategoryBox  ul#SiteCat  li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").append( "<span class='mobile_togglemenu'> </span>" );  
    $(".side-bar #CategoryBox  ul#SiteCat li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").addClass('toggle'); 
    $(".side-bar #CategoryBox  ul#SiteCat li.site-cat--has-dropdown .site-nav__childlist-item-dropdown .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').find('.grand-child-has-dropdown').slideToggle('slow'); 
    });    
}
$(document).ready(mobileToggleMenu11);


//------------------------------ Responsive left column------------------
function responsivecolumn()
{
	if ($(document).width() <= 990)
	{
		$('.main-content .page-width.contents .side-bar').insertAfter('.main-content .page-width.contents .main-container');
	}
 	 if ($(document).width() <= 989)
	{
		$('.header-middle .site-header__search').appendTo('.header-bottom ');
	}
}
$(document).ready(function(){responsivecolumn(); });
$(window).resize(function(){responsivecolumn(); });
 

//=====================================Insert after-before =============================//
if ($(window).width() > 749) {
	$('.main-content .page-width .custom-content .custom__item-inner--text').insertBefore('.main-content .sub-container .product-container-collection .collection.collection-1');
}

//======================== Sticky header ======================//
function StickyHeader(){	
	"use strict";	
	var num = 41; //number of pixels before modifying styles
	
		jQuery(window).bind('scroll', function () {
			if (jQuery(window).scrollTop() > num) {
				jQuery('.site-header .header-middle').addClass('sticky-header');
				
			} else {
				jQuery('.site-header .header-middle').removeClass('sticky-header');		
			}
		})
}
jQuery(document).ready(function() { "use strict";   StickyHeader()});
jQuery(window).resize(function() {  "use strict";   StickyHeader()});

